export function formatPrice(price) {
  var match = price.match(/([^\d]*)(\d+(\.\d+)?)([^\d]*)/);

  if (!match) {
    throw new Error('Invalid price format');
  }

  var currencyPrefix = match[1];
  var numericPart = parseFloat(match[2]);
  var currencySuffix = match[4];
  var formattedNumericPart = numericPart.toFixed(2);
  return "".concat(currencyPrefix).concat(formattedNumericPart).concat(currencySuffix);
}
export var formatWithCommas = function formatWithCommas(num, config) {
  if (typeof num !== 'number') return '';
  return num.toLocaleString((config === null || config === void 0 ? void 0 : config.formatLocale) || 'en-US');
};